import { DBSchema, IDBPDatabase } from "idb";
import { DB } from "./db";

// Use a unique prefix to avoid collisions with other applications using IndexedDB
// relevant when the WebReader is embedded through another domain
const WebReaderDbPrefix = "https://r.cantook.com/";

export type IdentifierRecord = {
  storagePath: string;
  identifier: string;
};

interface PublicationsSchema extends DBSchema {
  identifiers: {
    key: string;
    value: IdentifierRecord;
  };
}

export class PublicationsDB extends DB<PublicationsSchema> {
  constructor() {
    super(WebReaderDbPrefix + "publications-db", 1);
  }

  upgrade(
    db: IDBPDatabase<PublicationsSchema>,
    oldVersion: number,
    newVersion: number
  ) {
    db.createObjectStore("identifiers", { keyPath: "storagePath" });
  }

  public async getIdentifiers(): Promise<IdentifierRecord[]> {
    return await this.getAll("identifiers");
  }

  public async getIdentifier(storagePath: string): Promise<string | null> {
    const record = await this.get("identifiers", storagePath);
    if (!record) {
      return null;
    }
    return record.identifier || "";
  }

  public async setIdentifier(
    storagePath: string,
    identifier: string
  ): Promise<void> {
    await this.put("identifiers", { storagePath, identifier });
  }
}
